module.exports = __webpack_public_path__ + "49e6d0d42d3865f2ab5eb9dd5b863b2f.png";